import { Directive, forwardRef } from '@angular/core';
import { NG_VALIDATORS, FormControl, Validator, ValidationErrors } from '@angular/forms';

//Validates the aba #
@Directive({
  selector: '[aba-validator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => ABAValidator), multi: true, 
  }]
})
export class ABAValidator implements Validator {
  //routing number
  validate(c: FormControl): ValidationErrors | null {
    const numValue = c.value;
    console.log('validator', c);
    const isValid = this.routingNumberValid(numValue);
    const message = {
      'invalid routing number': {
        'message': 'The rounting number is invalid'
      }
    };
    return isValid ? null : message;
  }

  //vaidatate routing #
  routingNumberValid = (number: string) => {
    if (number) {
      if (number.length !== 9) {
        return false;
      }
      if (number.charAt(0) === '5') {
        return false;
      }

      let abaRegex = /^[012346789][0-9]{8}$/;
      let regEx = new RegExp(abaRegex);
      if (!regEx.test(number)) {
        return false;
      }
      return this._passesLuhnCheck(number);
    }
  }

  //vaidatate routing # with Luhn
  _passesLuhnCheck = (routing: string) => {
    var checksumTotal = (7 * (parseInt(routing.charAt(0), 10) + parseInt(routing.charAt(3), 10) + parseInt(routing.charAt(6), 10))) +
      (3 * (parseInt(routing.charAt(1), 10) + parseInt(routing.charAt(4), 10) + parseInt(routing.charAt(7), 10))) +
      (9 * (parseInt(routing.charAt(2), 10) + parseInt(routing.charAt(5), 10) + parseInt(routing.charAt(8), 10)));
    var checksumMod = checksumTotal % 10;
    if (checksumMod !== 0) return false;
    return true;
  }
}
